// 默认请求路径
const baseURL = {
  http:'https://slbstg.stc1518.com', // 正式地址（搜缘）
  // httpTC: 'http://192.168.9.250:6118'  // 曾勇福IP（椒易宝）
  httpTC: 'https://trad.hnbpepper.com',  // 正式地址（椒易宝）
  // httpTC: 'http://192.168.9.201:6118',  // 测试地址（椒易宝）
  // httpTC: 'https://slbstg.stc1518.com/jyzx'  // 测试地址（椒易宝）
  // httpHK: 'https://slbstg.stc1518.com/hkslb', // 香港手信（测试）
  httpHK: 'http://hkslbapi.mysoule.com'  // 香港手信（正式）
}

export default baseURL;



// WEBPACK FOOTER //
// ./src/common/api_url/baseURL.js